import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IPasswordValidationFields } from '../../../../../../globals/classes/password-validator';
import { PasswordBullets } from '../password-bullets';
import { AppSettings } from '../../../../../app.settings';

@Component({
	selector: 'password-validation',
	template: require('./password-validation.component.html'),
})
export class PasswordValidationComponent implements OnChanges {
	@Input() validation: IPasswordValidationFields;
	@Input() isNewChangePasswordModals: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	public strengthPercentage: number = 0;
	public listOfBullets: PasswordBullets[] = [
		{
			title: '8 εώς 15 χαρακτήρες',
			checked: false,
		},
		{
			title: 'Κεφαλαίοι λατινικοί χαρακτήρες',
			checked: false,
		},
		{
			title: 'Μικροί λατινικοί χαρακτήρες',
			checked: false,
		},
		{
			title: 'Αριθμοί και σύμβολα: (`~!@#$%^&*()-_=+[{]}|;:\'"<,>./?€£)',
			checked: false,
		},
	];

	public get areAllChecked(): boolean {
		return !this.listOfBullets.some((b) => !b.checked);
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.updatePasswordStrengthIndication();
	}

	public get text(): string {
		if (this.strengthPercentage <= 25) {
			if (!this.isNewChangePasswordModals) {
				return 'Χαμηλή';
			} else return '';
		} else if (this.strengthPercentage <= 75 && this.strengthPercentage > 25) {
			return 'Μέτρια';
		} else if (this.strengthPercentage <= 100 && this.strengthPercentage > 75) {
			return 'Ισχυρή';
		}
	}

	public get color(): string {
		if (this.strengthPercentage < 25) {
			return '';
		} else if (this.strengthPercentage <= 75 && this.strengthPercentage >= 25) {
			return 'action';
		} else if (this.strengthPercentage <= 100 && this.strengthPercentage > 75) {
			return 'secondary-1';
		}
	}

	private updatePasswordStrengthIndication() {
		this.updateListOfBullets();
		this.setPercentange();
	}
	private updateListOfBullets() {
		this.listOfBullets[0].checked =
			this.validation.lengthOk &&
			!this.validation.spaceCharExists &&
			this.validation.allowedCharactersOk;
		this.listOfBullets[1].checked = this.validation.uppercaseOk;
		this.listOfBullets[2].checked = this.validation.lowercaseOk;
		this.listOfBullets[3].checked = this.validation.digitsOk && this.validation.specialCharOk;
	}
	private setPercentange() {
		let newPercentage = 0;
		if (this.validation.lengthOk && this.validation.allowedCharactersOk) {
			newPercentage += 25;
		}
		if (this.validation.uppercaseOk) {
			newPercentage += 25;
		}
		if (this.validation.lowercaseOk) {
			newPercentage += 25;
		}
		if (this.validation.digitsOk && this.validation.specialCharOk) {
			newPercentage += 25;
		}
		this.strengthPercentage = newPercentage;
	}
}
